// src/Components/DownloadModal.jsx
import * as React from "react";
import PropTypes from "prop-types";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { PDFDownloadLink } from "@react-pdf/renderer";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

function DownloadModal({ onClose, open, pdfData, pdfProfileName, docx, drive, disabled }) {
  const handleListItemClick = (value) => {
    if (value === "DOCX") {
      docx();
    } else if (value === "Google Drive") {
      drive();
    }
    onClose();
  };

  return (
    <Dialog
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: "black",
          border: "3px solid",
          borderColor: "#380093",
          color: "white",
        },
      }}
    >
      <DialogTitle>Select File Type:</DialogTitle>
      <List sx={{ pt: 0 }}>
        {disabled ? (
          <ListItem className="border-b border-black bg-[#380093]" disableGutters>
            <ListItemButton disabled>
              <ListItemText primary="No Chats Available" className="text-inherit" />
            </ListItemButton>
          </ListItem>
        ) : (
          <>
            <ListItem className="border-b border-black bg-[#380093]" disableGutters>
              <ListItemButton>
                <PDFDownloadLink
                  document={pdfData}
                  fileName={`${pdfProfileName}.pdf`}
                  className="no-underline text-inherit w-full"
                >
                  <ListItemText primary="PDF" />
                </PDFDownloadLink>
              </ListItemButton>
            </ListItem>
            {/* Uncomment if you want DOCX option directly in modal */}
            {/* <ListItem className="border-b border-black bg-[#380093]" disableGutters>
              <ListItemButton onClick={() => handleListItemClick("DOCX")}>
                <ListItemText primary="DOCX" />
              </ListItemButton>
            </ListItem> */}
            <ListItem className="border-b border-black bg-[#380093]" disableGutters>
              <ListItemButton onClick={() => handleListItemClick("Google Drive")}>
                <ListItemText primary="Google Drive" />
              </ListItemButton>
            </ListItem>
          </>
        )}
        <ListItem className="border-b border-black bg-[#380093]" disableGutters>
          <ListItemButton autoFocus onClick={onClose}>
            <ListItemText primary="Cancel" />
          </ListItemButton>
        </ListItem>
      </List>
    </Dialog>
  );
}

DownloadModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  pdfData: PropTypes.any, // PDFDownloadLink accepts a React element
  pdfProfileName: PropTypes.string.isRequired,
  docx: PropTypes.func.isRequired,
  drive: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default function DownloadModalOptions({
  pdfData,
  pdfProfileName,
  docx,
  drive,
  disabled,
  className = "",
}) {
  const [open, setOpen] = React.useState(false);

  return (
    <div
      className={[
        "z-50 bg-[#380093] border border-[#5406D2] text-sm px-4 py-1 rounded-sm",
        "hover:bg-[#5406D2] hover:cursor-pointer",
        // default width/margins; override with className if needed
        "w-[150px] mt-1 ml-[20px] mr-[20px]",
        className,
      ].join(" ")}
    >
      <button onClick={() => setOpen(true)} className="flex justify-evenly items-center w-full text-white">
        Download
        <FileDownloadIcon className="ml-[8px]" />
      </button>
      <DownloadModal
        open={open}
        onClose={() => setOpen(false)}
        pdfData={pdfData}
        pdfProfileName={pdfProfileName}
        docx={docx}
        drive={drive}
        disabled={disabled}
      />
    </div>
  );
}

DownloadModalOptions.propTypes = {
  pdfData: PropTypes.any,
  pdfProfileName: PropTypes.string.isRequired,
  docx: PropTypes.func.isRequired,
  drive: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  className: PropTypes.string,
};
